<template>
  <div class="protocal">
    <div class="top">
      <ul>
        <li v-for="item of topList" :key="item.title" :class="[item.class]">
          <img :src="item.img" alt="" />
          <div class="top-item-right">
            <p class="title">{{ item.title }}</p>
            <p class="sub-title">{{ item.subTitle }}</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="bottom">
      <img :src="require('@/assets/imgs/pay/footer_logo.png')" alt="" />
      <div class="bottom-right">
        <p class="services" @click="goServices">
          {{ $t('pay.protocal.services') }}
        </p>
        <p class="policy" @click="goPolicy">
          {{ $t('pay.protocal.policy') }}
        </p>
        <p class="address">
          {{ $t('pay.protocal.address') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api';
import i18n, { getLocale } from '../../../i18n';

export default {
  setup() {
    const topList = [
      {
        img: require('@/assets/imgs/pay/-h-安全.png'),
        class: 'safe',
        title: i18n.t('pay.footer.safe.title'),
        subTitle: i18n.t('pay.footer.safe.subTitle')
      },
      {
        img: require('@/assets/imgs/pay/-h-购物车 (2).png'),
        class: 'convenient',
        title: i18n.t('pay.footer.convenient.title'),
        subTitle: i18n.t('pay.footer.convenient.subTitle')
      },
      {
        img: require('@/assets/imgs/pay/-h-%.png'),
        class: 'economical',
        title: i18n.t('pay.footer.economical.title'),
        subTitle: i18n.t('pay.footer.economical.subTitle')
      },
      {
        img: require('@/assets/imgs/pay/-h-高效.png'),
        class: 'efficient',
        title: i18n.t('pay.footer.efficient.title'),
        subTitle: i18n.t('pay.footer.efficient.subTitle')
      }
    ];
    const servicesUrl = computed(() => {
      switch (getLocale()) {
        case 'en':
          return 'https://sdk401.leniugame.com/uc/user/user_protocol?lang=en&appid=';
        case 'kr':
          return 'https://sdk401.wukogame.com/uc/user/user_protocol?lang=kr&appid=0';
        case 'zh':
        default:
          return 'https://sdk401.leniugame.com/uc/user/user_protocol?ln=1';
      }
    });
    const policyUrl = computed(() => {
      // 使用locale判断当前语言，而不是area，因为area有几个都属于英文
      switch (getLocale()) {
        case 'en':
          return 'https://sdk401.leniugame.com/uc/user/privacy_protocol?lang=en&appid=';
        case 'kr':
          return 'https://sdk401.wukogame.com/uc/user/privacy_protocol?lang=kr&appid=0';
        case 'zh':
        default:
          return 'https://sdk401.leniugame.com/uc/user/privacy_protocol?ln=1';
      }
    });

    function goServices() {
      window.open(servicesUrl.value, '_blank');
    }

    function goPolicy() {
      window.open(policyUrl.value, '_blank');
    }

    return {
      topList,
      servicesUrl,
      policyUrl,
      goServices,
      goPolicy
    };
  }
};
</script>

<style lang="scss" scoped>
.protocal {
  .top {
    padding: 0.6rem 0.8rem 0;
    ul {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 0.4rem;
      li {
        display: flex;
        align-items: center;

        img {
          width: 0.55rem;
        }
        .top-item-right {
          margin-left: 0.11rem;
          .title {
            font-family: SourceHanSansCN;
            font-weight: bold;
            font-size: 0.16rem;
            color: #000000;
          }

          .sub-title {
            font-family: SourceHanSansCN;
            font-weight: 400;
            font-size: 0.14rem;
            color: #969696;
          }
        }
      }
    }
  }
  .bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 0.4rem 0 0.9rem;
    > img {
      width: 2.43rem;
    }
    .bottom-right {
      margin-left: 0.2rem;

      font-family: SourceHanSansCN;
      font-size: 0.14rem;
      color: #000000;
      line-height: 0.26rem;

      .services {
      }
      .policy {
      }
      .address {
        font-weight: 600;
        padding: 0.16rem 0;
        white-space: break-spaces;
      }
    }
  }
}
</style>
